import React from 'react'
import { Typography } from '@material-ui/core';

function NotFound() {
	return (
		<Typography variant='h1' align='center'>
			404 Page not found.
		</Typography>
	)
}

export default NotFound
